import { FieldsEnum, RenewalChangedAddressEnum } from 'app/shared/enums';
import { homeAddressNotSameAsLegalChange } from 'app/services/businessFunctions/helpers/homeAddressNotSameAsLegalChange';
import { zipCodeChange } from 'app/services/businessFunctions/helpers/zipCodeChange';
import { addRenewalChangedAddress } from 'app/shared/helpers/addRenewalChangedAddress';

const ownerAddressDetails = {
  ownerHomeAddressNotSameAsLegalChange() {
    homeAddressNotSameAsLegalChange(
      FieldsEnum.OwnerHomeAddressNotSameAsLegal,
      FieldsEnum.OwnerHomeAddressZipCode,
      FieldsEnum.OwnerHomeAddressCity
    );
  },
  ownerHomeAddressZipCodeChange(initialRun: boolean) {
    addRenewalChangedAddress(initialRun, RenewalChangedAddressEnum.OwnerHome);

    zipCodeChange(initialRun, FieldsEnum.OwnerHomeAddressZipCode);
  },
  ownerHomeAddressCityChange(initialRun: boolean) {
    addRenewalChangedAddress(initialRun, RenewalChangedAddressEnum.OwnerHome);
  },
  ownerLegalAddressZipCodeChange(initialRun: boolean) {
    addRenewalChangedAddress(initialRun, RenewalChangedAddressEnum.OwnerLegal);

    zipCodeChange(initialRun, FieldsEnum.OwnerLegalAddressZipCode);
  },
  ownerLegalAddressCityChange(initialRun: boolean) {
    addRenewalChangedAddress(initialRun, RenewalChangedAddressEnum.OwnerLegal);
  },
};

export default ownerAddressDetails;
